import React from "react";
import FreelancerCard from "../components/FreelancerCard";
import { useLanguage } from "../context/LanguageContext";
import freelancersData from "../data/freelancers.js";

export default function FreelancersPage() {
  const { t } = useLanguage();

  const freelancers = Array.isArray(freelancersData) ? freelancersData : [];

  return (
    <div data-testid="freelancers-page">
      <section className="pt-20 pb-10 bg-[#FAFAF9]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6B5D]">
            {t.freelancers.label}
          </span>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] text-[#202C21] font-semibold max-w-3xl">
            {t.freelancersPage.title}
          </h1>
          <p className="mt-5 text-base sm:text-lg text-[#5C6B5D] leading-relaxed max-w-2xl">
            {t.freelancersPage.subtitle}
          </p>
        </div>
      </section>

      <section className="pb-24 lg:pb-32 bg-[#FAFAF9]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {freelancers.map((f, i) => (
              <FreelancerCard key={f.slug || i} freelancer={f} index={i} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}